<template>
  <div class="stat-container">
    <MatchStats :matchData="matchData" />
  </div>
</template>

<script>
import { BasketballApi } from "../api/basketball";
import MatchStats from "./components/matchschedule/MatchStats.vue";
export default {
  data() {
    return {
      matchData: "",
      matchId: ""
    };
  },
  created() {
    this.matchId = this.$route.params.id;
    this.getCompetitionDeatils();
  },
  components: {
    MatchStats
  },
  methods: {
    getCompetitionDeatils() {
      this.matchLoding = true;
      BasketballApi.getCompetitionDeatils(this.matchId).then(res => {
        this.matchData = res;
        this.matchData.first_team_member_total.team_name = this.matchData.first_team_name;
        this.matchData.second_team_member_total.team_name = this.matchData.second_team_name;
        const team_data_total = [];
        team_data_total.push(this.matchData.first_team_member_total);
        team_data_total.push(this.matchData.second_team_member_total);
        this.matchData.team_data_total = team_data_total;
        // this.matchData.first_team_members.push(
        //   this.matchData.first_team_member_total
        // );
        // this.matchData.first_team_data.first_team_name
        this.matchLoding = false;
        console.log(this.matchData);
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
